import { useMemo } from 'react';
import { truncate } from '../../../../../utils/helpers';
import { MA_DEALS_FIELDS_LABELS } from '../constants';
import { useGetDeals } from './useGetDeals';

export const useGetChartData = (filters, fields) => {
  const { data, loading, error } = useGetDeals(filters, fields);

  const customData = useMemo(
    () =>
      data?.map((d) => {
        if (!d?.maCompanyTransactions?.length) return ['', '', ''];

        const { assetNames, buyerNames, sellerNames } = d.maCompanyTransactions.reduce(
          (acc, c) => {
            return {
              assetNames: [...acc.assetNames, c?.maAssetTransactions?.map((a) => a?.assetName)],
              buyerNames: [...acc.buyerNames, c?.buyerCompany?.name],
              sellerNames: [...acc.sellerNames, c?.sellerCompany?.name],
            };
          },
          { assetNames: [], buyerNames: [], sellerNames: [] },
        );

        return [
          // remove duplicates and truncate at 100 chars
          truncate([...new Set(assetNames.flat())].join(', '), 100),
          truncate([...new Set(buyerNames)].join(', '), 100),
          truncate([...new Set(sellerNames)].join(', '), 100),
        ];
      }),
    [data],
  );

  const chartData = useMemo(
    () =>
      fields.map((field, idx) => {
        const label = MA_DEALS_FIELDS_LABELS[field] || field;
        return {
          x: data?.map((d) => d.effectiveDate) || [],
          y: data?.map((d) => d[field]) || [],
          name: label,
          type: 'scatter',
          mode: 'markers',
          yaxis: idx === 0 ? 'y' : 'y2',
          customdata: customData,
          hovertemplate: `Year: %{x|%Y}<br>${label}: %{y:,.2f}<br>Asset(s): %{customdata[0]}<br>Buyer: %{customdata[1]}<br>Seller: %{customdata[2]}<extra></extra>`,
        };
      }),
    [data],
  );

  if (!fields?.length) {
    return { chartData: [], loading: false, error: null };
  }

  return {
    chartData,
    loading,
    error,
  };
};
